import { Box } from '@mui/material';
import LogoImage from '../../assets/images/cw-folded-logo.jpg';

const LogoIcon = () => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center">
      <Box
        component="img"
        src={LogoImage}
        alt="Calderwood Logo"
        sx={{
          height: 'auto',
          width: '50px'
        }}
      />
    </Box>
  );
};

export default LogoIcon;
